// Formats de dates locale-aware pour les ecrans comites (i18n FR+EN — la lib
// src/lib/format/date.ts portee du PoC est fr-CA seulement ; ici la locale
// active i18next pilote le format, marche primaire fr-CA).

import type { SupportedLocale } from '../../i18n';

const intlLocale = (locale: string): string => (locale.startsWith('en') ? 'en-CA' : 'fr-CA');

/** ISO datetime -> date courte locale (« 2026-07-13 » / « July 13, 2026 »). */
export function formatDate(locale: SupportedLocale | string, iso: string): string {
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return '—';
  return new Intl.DateTimeFormat(intlLocale(locale), { day: 'numeric', month: 'long', year: 'numeric' }).format(d);
}

/**
 * Date-only 'YYYY-MM-DD' -> forme longue locale, formatee en UTC (minuit UTC
 * reculerait d'un jour dans un fuseau negatif — meme piege que formatDateOnlyFr).
 */
export function formatDateOnly(locale: SupportedLocale | string, dateStr: string): string {
  const d = new Date(`${dateStr}T00:00:00Z`);
  if (Number.isNaN(d.getTime())) return dateStr;
  return new Intl.DateTimeFormat(intlLocale(locale), {
    day: 'numeric', month: 'long', year: 'numeric', timeZone: 'UTC',
  }).format(d);
}
